import React from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import { TestingComponent } from "@/components/testing/TestingComponent";

const TestingPage = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-6">
        <div className="space-y-6">
          <div className="border-b border-border pb-4">
            <h1 className="text-3xl font-bold text-foreground">Calie.ai Testing Suite</h1>
            <p className="text-muted-foreground mt-2">
              Comprehensive end-to-end testing for Calie.ai onboarding flows, Twilio integration, and call handling
            </p>
          </div>
          
          <TestingComponent />
        </div>
      </div>
    </MainLayout>
  );
};

export default TestingPage;